<template>
  <!-- 预览按钮 -->
  <AttrGroup
    v-if="
      isSprite ||
      (isVideo &&
        (androidWatcfaceOS == 'not-android-device' ||
          androidWatcfaceOS == 'android'))
    "
    title="预览"
  >
    <a-button class="!w-full bg-black-active" @click="play"> 预览 </a-button>
  </AttrGroup>
</template>

<script lang="ts" setup>
import { useCanvasPlay, useWatchfaceAndroid } from '@/hooks';
import { Shape } from '@/services/shape';
import { PropType } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  isSprite: {
    type: Boolean,
    required: true
  },
  isVideo: {
    type: Boolean,
    required: true
  }
});

const { androidWatcfaceOS } = useWatchfaceAndroid();

const { playFrameAni } = useCanvasPlay();
const play = () => {
  playFrameAni(props.shape.id);
};
</script>
